import { render, staticRenderFns } from "./ActiveProfileSearchControl.vue?vue&type=template&id=2b710d76"
import script from "./ActiveProfileSearchControl.vue?vue&type=script&lang=js"
export * from "./ActiveProfileSearchControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports